import { render, staticRenderFns } from "./attrDetails.vue?vue&type=template&id=7779b1e8&scoped=true&"
import script from "./attrDetails.vue?vue&type=script&lang=js&"
export * from "./attrDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7779b1e8",
  null
  
)

component.options.__file = "attrDetails.vue"
export default component.exports